import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectWeekComponent } from './select-week/select-week.component';
import { ReactiveFormsModule } from '@angular/forms';
import { SelectPartnerComponent } from './select-partner/select-partner.component';
import { SelectFacilityComponent } from './select-facility/select-facility.component';
import { FormModule } from '@coreui/angular-pro';

import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { CustomHeaderInterceptor } from '@infrastructure/interceptors/CustomHeaderInterceptor';import { DatesService } from '@infrastructure/services/alpura/dates.service';
import { PartnerService } from '@infrastructure/services/alpura/partner.service';
import { PlantasService } from '@infrastructure/services/catalog/plantas.service';



@NgModule({
  imports: [
    ReactiveFormsModule,
    HttpClientModule,
    CommonModule,
    FormModule,
  ],
  declarations: [SelectWeekComponent, SelectPartnerComponent, SelectFacilityComponent],
  providers: [DatesService, PartnerService, PlantasService, 
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CustomHeaderInterceptor,
      multi: true,
    },],
  exports: [SelectWeekComponent, SelectPartnerComponent, SelectFacilityComponent]
})
export class SelectedsModule { }
